import { render, staticRenderFns } from "./scaffold-form.vue?vue&type=template&id=1e04a3dc&"
import script from "./scaffold-form.vue?vue&type=script&lang=js&"
export * from "./scaffold-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports